import React, { useState } from "react";
import { imageUploader } from "../../../../../utilities/fileHandlers";
import Input from "../../../customs/Input"
import SelectOption from "../../../customs/SelectOption";
import DynamicAdOns from "./DynamicAdOns";
import Meal from "./Meal";

export default function DynamicMeal({ day, index, addMeal, disabled }) {
    const [addOns, setaddOns] = useState([]);

    const [meal, setMeal] = useState({
        meal_name: "",
        day: day,
        slot: "",
        type: "",
        description: "",
        image: "",
        add_on: addOns,
    });
    const [meals, setMeals] = useState([])
    const [mealImage, setMealImage] = useState("");
    const [loading, setLoading] = useState(false);
    const [alerting, setAlert] = useState(false)

    const onChangeText = (index, event) => {
        const { name, value } = event.target;
        setMeal((prevState) => ({ ...prevState, [name]: value }));
    };

    const handle = (data) => {
        setMeal({ ...meal, image: data })
    }

    const onImageChange = (index, e) => {
        const { name } = e.target.files[0]
        setMealImage(name)
        imageUploader(e.target.files[0], handle)
    }

    const done = () => {
        let currentMeals = [...meals]
        currentMeals.length < 3 ? currentMeals.push(meal) : setAlert(true)
        setMeals(currentMeals)
        const { slot } = meal
        addMeal(slot, meal);
    };
    if (alerting) {
        return (alert('Cannot add more than two meals a day'))
    } else {
        return (
            <fieldset key={index}>
                {meals.length > 0 &&
                    <div className="row">
                        {
                            meals.map((meal, index) => (
                                <div className="col-6" key={index}>
                                    <Meal meal={meal} index={index} />
                                </div>
                            ))
                        }
                    </div>
                }
                <div className="row mt-1">
                    <div className="col-12 justify-content-end">
                        <button
                            type="button"
                            className="btn btn-primary float-right mr-2 "
                            onClick={done}
                            disabled={disabled}
                        >
                            Save
                        </button>
                    </div>
                </div>

                <div className="row mt-2">
                    <div className="col-4">
                        <SelectOption
                            label="available as"
                            required={true}
                            name="slot"
                            values={[
                                { name: 'Choose an option', value: '' },
                                { name: 'Lunch', value: 'Lunch' },
                                { name: 'Dinner', value: 'Dinner' }
                            ]}
                            handler={(e) => onChangeText(index, e)}
                        />
                    </div>
                    <div className="col-4">
                        <SelectOption
                            label="available as"
                            required={true}
                            name="type"
                            values={[
                                { name: 'Choose an option', value: '' },
                                { name: 'Veg', value: 'veg' },
                                { name: 'Non-Veg', value: 'non-veg' }
                            ]}
                            handler={(e) => onChangeText(index, e)}
                        />
                    </div>
                    <div className="col-4">
                        <Input
                            label="meal name"
                            type="text"
                            name="meal_name"
                            required={true}
                            handler={(e) => onChangeText(index, e)}
                        />
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-4">
                        <div className="form-group">
                            <label>Meal Image</label>
                            <div className="custom-file">
                                <input
                                    id="logo"
                                    type="file"
                                    className="custom-file-input"
                                    onChange={(e) => onImageChange(index, e)}
                                />
                                <label htmlFor="logo" className="custom-file-label">
                                    {mealImage}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="col-8">
                        <div className="form-group">
                            <label>
                                Meal Description <strong className="text-danger">*</strong>
                            </label>
                            <textarea
                                className="form-control form-control-plaintext"
                                name="description"
                                onChange={(e) => onChangeText(index, e)}
                            />
                        </div>
                    </div>
                </div>
                <DynamicAdOns day={day} handleChangeInput={onChangeText} />
            </fieldset>
        );
    }
}
